import { NotFoundPage } from 'pages/NotFoundPage/NotFoundPage';
import OverviewPage from './Overview';

export const dashboardRoutes = [
  {
    path: '/dashboard/overview',
    element: <OverviewPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];
